import React from 'react';
import { Sparkles, Clock } from 'lucide-react';
import { useFreemium } from '../context/FreemiumContext';

/**
 * Banner discreto que se muestra durante una ventana de contingencia global
 * activada desde el backend (`GLOBAL_ACCESS_OVERRIDE_UNTIL`).
 *
 * Mientras esté activa, todos los usuarios operan con acceso completo sin
 * consumir créditos ni ver paywalls. No modifica ningún dato en BD.
 */
export default function ContingencyBanner() {
    const { status } = useFreemium();
    const overrideActive = !!status?.global_access_override_active;
    const grantActive = !!status?.user_access_grant_active;
    if (!overrideActive && !grantActive) return null;
    // Prioridad: si el grant individual está activo (autorización selectiva),
    // se muestra ese mensaje. El global tiene mensaje genérico.
    const endIso = grantActive
        ? status.user_access_grant_end_iso
        : status.global_access_override_end_iso;
    let endHuman = '';
    if (endIso) {
        try {
            const d = new Date(endIso);
            endHuman = d.toLocaleString('es-CL', {
                timeZone: 'America/Santiago',
                weekday: 'long',
                day: '2-digit',
                month: 'long',
                hour: '2-digit',
                minute: '2-digit',
            });
        } catch { endHuman = endIso; }
    }
    const titulo = grantActive
        ? 'Acceso especial habilitado para ti'
        : 'Sigue trabajando en tu Portafolio sin restricciones';
    const bajada = grantActive
        ? 'Se te otorgó acceso completo temporal a Portafolio Digital Docente. Podrás usar todas las funcionalidades sin bloqueos hasta la fecha indicada.'
        : 'Estamos finalizando los ajustes del sistema de pagos. Mientras tanto, todos los usuarios tienen acceso completo a la plataforma sin consumo de créditos ni bloqueos por plan.';
    const uppercase = grantActive ? 'Acceso especial vigente' : 'Acceso extendido temporalmente';
    return (
        <div
            data-testid="contingency-banner"
            className="rounded-xl border border-emerald-200 bg-gradient-to-r from-emerald-50 to-teal-50 p-4 sm:p-5 shadow-sm"
        >
            <div className="flex items-start gap-3">
                <div className="grid place-items-center h-9 w-9 rounded-lg bg-emerald-600 text-white shrink-0">
                    <Sparkles className="h-4 w-4" />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="text-[10px] font-bold uppercase tracking-widest text-emerald-800">
                        {uppercase}
                    </div>
                    <div className="font-heading text-base sm:text-lg font-semibold text-slate-900">
                        {titulo}
                    </div>
                    <p className="mt-1 text-xs sm:text-sm text-slate-700 leading-relaxed">
                        {bajada}
                    </p>
                    {endHuman && (
                        <div className="mt-2 flex items-center gap-1.5 text-xs text-emerald-800 font-medium">
                            <Clock className="h-3.5 w-3.5" />
                            Ventana hasta: {endHuman}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
